/**
 * Returns the magCode to be used for legacy lookup. 
 * This allows a site to have a default magazine set 
 * up as a Resin title.
 *
 * @param adminConfig - Admin Tool configs
 * @param clientConfig - Client Config
 * @returns 
 */
export function getLookupMagCode (adminConfig: any, clientConfig: any) {
  let instanceMag = clientConfig.magCode;
  let products: Array<string> = [];
  if (adminConfig[instanceMag] && adminConfig[instanceMag].ClientProperties.ProductType === 'Resin') {
    Object.keys(adminConfig).forEach(key => {
      if (key !== '*' && adminConfig[key].ClientProperties.ProductType !== 'Resin') {
        products.push(key);
      }
    });
  }
  return products[0] || clientConfig.magCode;
}
